import { render, staticRenderFns } from "./CashRecord.vue?vue&type=template&id=28c3128b"
import script from "./CashRecord.vue?vue&type=script&lang=js"
export * from "./CashRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports